<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Muatnaik Panduan Permohonan</strong>
          </div>
          Muatnaik Fail (*.pdf)
          <br>
          <input :rows="3" class="mt-1" type="file" id="file" ref="file" accept=".pdf" v-on:change="handleFileUploadV4()"/>
          <div slot="footer">
            <b-button type="submit" variant="primary" v-on:click="submitFileV4()">
              <i class="fa fa-dot-circle-o"></i> Muat Naik
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import moment from "moment";
Vue.use(require("vue-moment"));

export default {
  name: "upload-panduan-permohonan-v4",
  components: {
    moment,
  },
  data: function() {
    return {
      actualURL: null,
      path: null,
      pdfToBeUploaded: null,
      file: '',
      loading: true,
      sCFN: 'UploadPanduanPermohonanV4: ',
    };
  },
  async mounted() {
    let fN = 'mounted: ';
    let isAuth = await this.UserAuth();
    if (isAuth) {
      this.loading = false;
    }
    this.HTECHLogger(this.sCFN + fN + this.$applicationGuideDocumentURL);
  },
  computed: {
  },
  methods: {
    handleFileUploadV4() {
      const files = event.target.files
      let filename = files[0].name
      var ext = filename.split('.').pop();
      if (ext != "pdf") {
        this.$dialog.alert("Muat naik fail pdf sahaja");
      } else {
        {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            this.documentUrl = fileReader.result
          })
          fileReader.readAsDataURL(files[0]);
          this.file = files[0];
          let obj = {
            name : this.file.name,
            file : files[0]
          }
          this.pdfToBeUploaded = obj;
        }
      }
    },
    submitFileV4() {
      let item = this.pdfToBeUploaded;
      if (typeof item.file.size === 'undefined') {
        this.$dialog.alert("Fail kosong");
      } else {
        {
          const formData = new FormData();
          formData.append("file", item.file);
          formData.append("docName", "Garis Panduan Permohonan Pinjaman MARA.pdf");
          return this.$API
            .post(this.$UploadApplicationGuideDocument, formData, { withCredentials: true, })
            .then((response) => {
              if (response.status == 200) {
                this.$dialog.alert("Muat Naik PDF Berjaya");
                console.log("Upload PDF Success");
                //this.$refs.fileref[index].value = null;
              } else {
                console.log("Error Saving");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  }
};
</script>